webpackJsonp([201803807800378],{

/***/ 1283:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PriceTier","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"tier","type":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"unitFee","type":{"enumValues":null,"fields":null,"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-price-tier-cc93b1bf1f7ad38b5842.js